import { 
  OFFICES_GET_OFFICES, 
  PENDING, FULFILLED, REJECTED,
} from '../globals';

export const initialState = {
  isLoading: false,
  status: false,
  error: false,
  data: [],
  errorMessage: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${OFFICES_GET_OFFICES}_${PENDING}`:
      return {
        ...initialState,
        isLoading: true,
      };

    case `${OFFICES_GET_OFFICES}_${FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        data: action.payload.data,
      };

    case `${OFFICES_GET_OFFICES}_${REJECTED}`:
      return {
        ...state,
        isLoading: false,
        status: false,
        error: true,
        errorMessage: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;